export const UPDATE_URL_GROUP_ORDER_NAME = "update_url_group_order";
export const UPDATE_URL_GROUP_ORDER_DESC =
  "Update the order of URL groups for Search Analytics or User Analytics projects.";
